import React, { useEffect, useState } from "react";
import { ContentContainer } from "../../../components/layout";
import {
  Button,
  LoadingComponent,
  NoDataFoundTemplate,
  Select,
  Table,
} from "../../../components/core";
import { useQuery, useApolloClient, useLazyQuery } from "@apollo/client";
import {
  BRANCHES,
  PARTNERS,
} from "../../../constants/graphql/partner-agent-queries";
import { useDispatch, useSelector } from "react-redux";
import {
  getBranchReducer,
  getPartnersReducer,
  setSearchDataReducer,
  setSearchFieldReducer,
} from "../../../features/branches/search-branches-slice";
import TableHead from "../../../components/core/table/components/table-head";
import { useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";
import TotalRecords from "../../../components/core/total-records";
function omitEmptyAndMinusOneFields(obj) {
  const result = {};
  for (const key in obj) {
    // Exclude null, undefined, empty string, and -1 values
    if (obj[key] !== "-2") {
      result[key] = obj[key];
    }
  }
  return result;
}
export default function Branches() {
  const accessPermission = useSelector(
    (state) => state.accessPermissions.accessPermissions
  );
  const client = useApolloClient();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const partnerList = useSelector((state) => state.searchBranches.partnerList);
  const branchList = useSelector((state) => state.searchBranches.branchList);
  const searchField = useSelector((state) => state.searchBranches.searchField);

  console.log({ searchField });
  const searchData = useSelector((state) => state.searchBranches.searchData);
  const [isClicked, setIsClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Local States
  const [searchResultSentence, setSearchResultSentence] =
    React.useState("Search result for ");

  const getPartners = useQuery(PARTNERS, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
    },
  });
  const [getBranches, { loading }] = useLazyQuery(BRANCHES);
  // const getBranchesAll = useQuery(BRANCHES,{variables:{operatorId: JSON.parse(localStorage.getItem('user')).operator_id}})

  useEffect(() => {
    dispatch(
      setSearchFieldReducer({
        operatorId: localStorage.getItem("user")
          ? JSON.parse(localStorage.getItem("user")).operator_id
          : "",
      })
    );
  }, []);
  const handleOnChange = (event) => {
    switch (event.target.name) {
      case "partners":
        dispatch(setSearchFieldReducer({ partnerId: event.target.value }));
        break;
      case "branches":
        dispatch(
          setSearchFieldReducer({ partnerBranchId: event.target.value })
        );
        break;
      default:
        break;
    }
  };

  console.log({ searchField });
  const handleOnSearch = (event) => {
    setIsClicked(true);
    setIsLoading(true);
    // const filteredObject = omitEmptyAndMinusOneFields(searchField);
    // console.log(filteredObject);
    const isAllSelected = searchField.partnerId === "-2";
    const filteredObject = omitEmptyAndMinusOneFields({
      ...searchField,
      partnerId: isAllSelected ? null : searchField.partnerId,
    });

    console.log({ filteredObject, isAllSelected });
    let tempVar = [];
    getBranches({ variables: filteredObject }).then((data) => {
      data.data.partnerBranches.forEach((element) => {
        let modifiedElement = {
          ...element,
          partnerBranch: `${
            element.branchLevel === 0 || element.branchLevel === "0" ? "* " : ""
          }${element.partnerBranch}${
            element.branchLevel === 0 ? " (Head office)" : ""
          }`,
        };
        tempVar.push(modifiedElement);
      });
      dispatch(setSearchDataReducer(tempVar));
    });
    console.log(filteredObject);
    if (filteredObject.partnerId) {
      setSearchResultSentence(`Search result for
			${partnerList.find((x) => x.value === searchField.partnerId).name}
			branches`);
    } else {
      setSearchResultSentence(`Search result for ALL Branches`);
    }
  };

  React.useEffect(() => {
    // client.clearStore();
    if (getPartners.data) {
      var tempVar = [];
      getPartners.data.partners.forEach((element) => {
        tempVar.push({
          value: element.partnerId,
          name: element.companyNickname,
        });
      });
      dispatch(getPartnersReducer(tempVar));
    }
  }, [getPartners.data]);
  // React.useEffect(() => {
  // 	console.log(searchData);
  // }, [searchData]);
  // React.useEffect(()=>{
  //     if(getBranchesAll.data){
  //         var tempVar = []
  //         getBranchesAll.data.partnerBranches.forEach(element => {
  //             tempVar.push({
  //                 value: element.partnerBranchId,
  //                 name:element.partnerBranch
  //             })
  //         });
  //         dispatch(getBranchReducer(tempVar))
  //     }
  // },[getBranchesAll.data])
  // React.useEffect(()=>{
  //     if(searchField.partnerId === '-2'){
  //         if(getBranchesAll.data){
  //             var tempVar = []
  //             getBranchesAll.data.partnerBranches.forEach(element => {
  //                 tempVar.push({
  //                     value: element.partnerBranchId,
  //                     name:element.partnerBranch
  //                 })
  //             });
  //             dispatch(getBranchReducer(tempVar))
  //         }
  //     }
  //     if(searchField.partnerId !== '-2'){
  //         getBranches({variables:{operatorId: JSON.parse(localStorage.getItem('user')).operator_id, partnerId: searchField.partnerId}}).then((data)=>{
  //             if(data.data.partnerBranches){
  //                 var tempVar = []
  //                 data.data.partnerBranches.forEach(element => {
  //                     tempVar.push({
  //                         value: element.partnerBranchId,
  //                         name:element.partnerBranch
  //                     })
  //                 });
  //                 dispatch(getBranchReducer(tempVar))
  //             }
  //         })
  //     }
  // },[searchField.partnerId])

  return (
    <ContentContainer containerTitle={"Branches"}>
      <div className="grid grid-cols-5 gap-2 w-2/3 mb-2">
        <div className="col-span-1">
          <p className="text-base mt-2">Partner: </p>
        </div>
        <div className="bg-slate-50 col-span-3">
          <Select
            items={partnerList}
            defaultOption={{ value: "-2", name: "-- All --" }}
            name="partners"
            onChange={handleOnChange}
            value={searchField.partnerId}
          />
        </div>
        <div className="col-span-1">
          <Button
            className={"w-full h-full"}
            value="Search"
            onClick={handleOnSearch}
          />
        </div>
        {/* //!------------------------------------------------------------- */}
        {/* <>
                    <div className="col-span-1">
                    <p className='text-base mt-2'>Branch: </p>
                </div>
                <div className="bg-slate-50 col-span-3">
                    <Select items={branchList} defaultOption={{value:"-2",name:"-- All --"}}
                    name="branches" onChange={handleOnChange} value={searchField.partnerId}/>
                </div>
                <div className="col-span-1 grid grid-cols-2 gap-2">
                    <Button className={"w-full h-full"} value="Search" onClick={handleOnSearch}/>
                    <u className='flex hover:text-blue-500 cursor-pointer'>
                        <i className="fas fa-undo my-auto"></i>
                        <p className='my-auto ml-1'>Reset</p>
                    </u>
                </div> 
                </> */}
      </div>
      {/* //!------------------------------TABLE------------------------------- */}
      <Button
        disabled={
          accessPermission.branches === 1 || accessPermission.branches === "1"
        }
        className={"p-2 mb-2"}
        value="Add new"
        onClick={
          () => window.open(`/operator/admin/branches/add-branch`, "_blank")
          // navigate(`/branches/add-branch`)
        }
      />

      {loading && <LoadingComponent />}
      {isClicked &&
        (searchData.length > 0 ? (
          <div className={`${loading ? "hidden" : ""}`}>
            <TotalRecords count={searchData.length} />
            <div className="bg-primary-primaryYellow w-full h-24 border-stone-400 border-b-2 text-center">
              <p className="font-bold text-lg m-auto p-2">
                {" "}
                {searchResultSentence}
              </p>
              <div className="flex flex-row-reverse">
                {/* <button className="p-2 bg-green-600 font-bold text-white rounded-md m-2 ml-auto">
						<CSVLink data={searchData} filename="branches-report">
							Download CSV
						</CSVLink>
					</button> */}
                {/* <button
								className="p-2 bg-green-600 font-bold text-white rounded-md m-2"
								onClick={exportCSV}
							>
								Download Excel
							</button> */}
              </div>
            </div>
            <Table
              headers={[
                { header_name: "Branch Name", header_key: "partnerBranch" },
                // { header_name: "Address", header_key: "address" },
                { header_name: "Contact Person", header_key: "contactPerson" },
                { header_name: "Landline", header_key: "landline" },
                { header_name: "Mobile Number", header_key: "mobile" },
                { header_name: "Load Balance", header_key: "loadBalance" },
                { header_name: "", header_key: "actions" },
              ]}
              items={searchData}
              linkName={"partnerBranch"}
              // linkBody={`branches/branch-profile`}
              linkBody={`branches/edit-branch`}
              fieldId="partnerBranchId"
            />
          </div>
        ) : (
          <NoDataFoundTemplate />
        ))}
    </ContentContainer>
  );
}
